import "./App.css";
import LoadMoreApiData from "./components/LoadMoreApiData";
import LoadMoreStaticData from "./components/LoadMoreStaticData";
// import LoadMoreStaticData from "./components/LoadMoreStaticData";

function App() {
  return (
    <div className="App">
      <h1>Fitur Load More dengan React</h1>
      <div className="content__container">
        <div style={{ marginRight: "32px" }}>
          <h2>Load More dengan Data Statis</h2>
          <LoadMoreStaticData />
        </div>
        <div style={{ marginLeft: "32px" }}>
          <h2>Load More dengan Data dari API</h2>
          <LoadMoreApiData />
        </div>
      </div>
    </div>
  );
}

export default App;
